/**
 * "Compliance & subprocessors" — Trust section (ADR-0074).
 * Status verbs mirror compliance-status.json EXACTLY: SOC 2 Type I/II + ISO 27001
 * are "planned" (Vanta-tracked, not held); GDPR DPA + CCPA are "available"; EU AI
 * Act Art. 50 is "in progress"; HIPAA + FedRAMP are "out of scope". Subprocessors
 * point at the canonical /trust/subprocessors list (subprocessors.json). Never
 * claims an unheld certification.
 */
import type { DocPageContent } from '../types';

export const TRUST_COMPLIANCE_PAGE: DocPageContent = {
  slug: 'trust/compliance',
  titleKey: 'docs.trust.compliance.title',
  descriptionKey: 'docs.trust.compliance.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.trust.compliance.lead' },

    { kind: 'heading', level: 2, id: 'gdpr', textKey: 'docs.trust.compliance.gdpr.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.compliance.gdpr.body' },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.trust.compliance.dpa.title',
      textKey: 'docs.trust.compliance.dpa.body',
      links: {
        dpa: { target: { path: '/trust/dpa' }, labelKey: 'docs.trust.common.link.dpa' },
      },
    },

    {
      kind: 'heading',
      level: 2,
      id: 'certifications',
      textKey: 'docs.trust.compliance.certs.heading',
    },
    { kind: 'paragraph', textKey: 'docs.trust.compliance.certs.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.trust.compliance.cert.soc2.term',
          descKey: 'docs.trust.compliance.cert.soc2.desc',
        },
        {
          termKey: 'docs.trust.compliance.cert.iso.term',
          descKey: 'docs.trust.compliance.cert.iso.desc',
        },
        {
          termKey: 'docs.trust.compliance.cert.aiact.term',
          descKey: 'docs.trust.compliance.cert.aiact.desc',
        },
        {
          termKey: 'docs.trust.compliance.cert.scope.term',
          descKey: 'docs.trust.compliance.cert.scope.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.trust.compliance.status.title',
      textKey: 'docs.trust.compliance.status.body',
      links: {
        compliance: {
          target: { path: '/trust/compliance' },
          labelKey: 'docs.trust.common.link.compliance',
        },
      },
    },

    {
      kind: 'heading',
      level: 2,
      id: 'subprocessors',
      textKey: 'docs.trust.compliance.sub.heading',
    },
    { kind: 'paragraph', textKey: 'docs.trust.compliance.sub.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.trust.compliance.sub.note.title',
      textKey: 'docs.trust.compliance.sub.note.body',
      links: {
        subprocessors: {
          target: { path: '/trust/subprocessors' },
          labelKey: 'docs.trust.common.link.subprocessors',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.trust.compliance.next.privacy.title',
          textKey: 'docs.trust.compliance.next.privacy.text',
          to: { docSlug: 'trust/privacy' },
        },
        {
          titleKey: 'docs.trust.compliance.next.ai.title',
          textKey: 'docs.trust.compliance.next.ai.text',
          to: { docSlug: 'trust/ai' },
        },
      ],
    },
  ],
};
